import { Box, Divider } from 'ui/mui';
import FooterWave from 'ui/components/PageFooter/FooterWave';
import { darkModeColors } from 'ui/theme/theme';
import { FooterListItems, FooterList } from './FooterListItems';
import {
  FooterBottomBar,
  FooterBottomBarLinkItem,
} from './footer-bottom-bar/FooterBottomBar';
import { FooterLogoSection } from './FooterLogoSection';

type FooterProps = {
  list1?: FooterList;
  list2?: FooterList;
  list3?: FooterList;
  list4?: FooterList;
  maxWidth?: number;
  bottomBarLinks: FooterBottomBarLinkItem[];
};

export const Footer = ({
  list1,
  list2,
  list3,
  list4,
  maxWidth,
  bottomBarLinks,
}: FooterProps) => {
  const lists = [list1, list2, list3, list4].filter(Boolean);
  const hasContent = lists.length > 0;

  return (
    <Box>
      <FooterWave />
      <Box
        sx={{
          width: '100%',
          backgroundColor: 'background.default',
        }}
      >
        <Box
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: darkModeColors.primary.dark,
            color: darkModeColors.text.primary,
            '& a:focus-visible': {
              outlineColor: '#fff',
              color: `${darkModeColors.text.primary}`,
            },
          })}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'left',
              px: 3,
              mx: 'auto',
              width: '100%',
              maxWidth,
            }}
          >
            <FooterListItems lists={lists} sx={{ px: 0, py: 4 }} />
            {hasContent && (
              <Divider
                sx={{
                  background: '#FF6E40',
                  borderWidth: 2,
                  my: 2,
                }}
              />
            )}
            <FooterLogoSection sx={{ px: 0, py: 4 }} />
          </Box>
        </Box>
        <FooterBottomBar maxWidth={maxWidth} links={bottomBarLinks} />
      </Box>
    </Box>
  );
};
